import { Action, ContextState } from '../types/context-types'

export const globalStateReducer = (state: ContextState, action: Action) => {
  switch (action.type) {
    case 'UIStatusUpdate':
      return {
        ...state,
        UIStatus: action.payload
      }
    case 'configSettings':
      return {
        ...state,
        configSettings: action.payload
      }
    case 'synergy':
      return {
        ...state,
        synergy: action.payload
      }
    case 'persistUI':
      return {
        ...state,
        persistUI: action.payload
      }
    case 'keysHeld':
      return {
        ...state,
        keysHeld: action.payload
      }
    default:
      return state
  }
}